// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../api/types.generated';

import { SubpagesMenu_Subpage_Fragment, SubpagesMenu_HoldCoSubpage_Fragment } from './SubpagesMenu.generated';
import { gql } from '@apollo/client';
import { SubpagesMenuFragmentDoc } from './SubpagesMenu.generated';
import * as Apollo from '@apollo/client';
export type DeleteSubpageMutationVariables = Types.Exact<{
  subpageId: Types.Scalars['ID'];
  subjectType: Types.Scalars['String'];
}>;


export type DeleteSubpageMutation = (
  { readonly __typename: 'Mutation' }
  & { readonly deleteSubpage?: Types.Maybe<(
    { readonly __typename: 'DeleteSubpageMutation' }
    & Pick<Types.DeleteSubpageMutation, 'success'>
  )> }
);

export type SubpageOverview_Subpage_Fragment = (
  { readonly __typename: 'Subpage' }
  & Pick<Types.Subpage, 'id' | 'slug' | 'title' | 'description' | 'restricted'>
  & { readonly roles?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'Role' }
    & Pick<Types.Role, 'id' | 'name'>
  )>>, readonly groups?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'UserGroup' }
    & Pick<Types.UserGroup, 'id' | 'name'>
  )>> }
);

export type SubpageOverview_HoldCoSubpage_Fragment = (
  { readonly __typename: 'HoldCoSubpage' }
  & Pick<Types.HoldCoSubpage, 'id' | 'slug' | 'title' | 'description' | 'restricted'>
  & { readonly roles?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'Role' }
    & Pick<Types.Role, 'id' | 'name'>
  )>>, readonly groups?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'UserGroup' }
    & Pick<Types.UserGroup, 'id' | 'name'>
  )>> }
);

export type SubpageOverviewFragment = SubpageOverview_Subpage_Fragment | SubpageOverview_HoldCoSubpage_Fragment;

export type FundEntityOverview_Portfolio_Fragment = (
  { readonly __typename: 'Portfolio' }
  & Pick<Types.Portfolio, 'id' | 'name' | 'hasSubpages' | 'subpagePermissions'>
  & { readonly subpages?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'Subpage' }
    & SubpageOverview_Subpage_Fragment
    & SubpagesMenu_Subpage_Fragment
  ) | (
    { readonly __typename: 'HoldCoSubpage' }
    & SubpageOverview_HoldCoSubpage_Fragment
    & SubpagesMenu_HoldCoSubpage_Fragment
  )>>, readonly netYields?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'NetYield' }
    & Pick<Types.NetYield, 'id' | 'year' | 'actualEnergy' | 'p50' | 'p90'>
  )>>, readonly projects?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'Project' }
    & Pick<Types.Project, 'id' | 'name' | 'capacity' | 'type'>
    & { readonly location: (
      { readonly __typename: 'ProjectLocation' }
      & Pick<Types.ProjectLocation, 'latitude' | 'longitude'>
    ) }
  )>>, readonly org: (
    { readonly __typename: 'Organization' }
    & Pick<Types.Organization, 'slug'>
  ) }
);

export type FundEntityOverview_HoldingCompany_Fragment = (
  { readonly __typename: 'HoldingCompany' }
  & Pick<Types.HoldingCompany, 'id' | 'name' | 'hasSubpages' | 'subpagePermissions'>
  & { readonly subpages?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'Subpage' }
    & SubpageOverview_Subpage_Fragment
    & SubpagesMenu_Subpage_Fragment
  ) | (
    { readonly __typename: 'HoldCoSubpage' }
    & SubpageOverview_HoldCoSubpage_Fragment
    & SubpagesMenu_HoldCoSubpage_Fragment
  )>>, readonly netYields?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'NetYield' }
    & Pick<Types.NetYield, 'id' | 'year' | 'actualEnergy' | 'p50' | 'p90'>
  )>>, readonly projects?: Types.Maybe<ReadonlyArray<(
    { readonly __typename: 'Project' }
    & Pick<Types.Project, 'id' | 'name' | 'capacity' | 'type'>
    & { readonly location: (
      { readonly __typename: 'ProjectLocation' }
      & Pick<Types.ProjectLocation, 'latitude' | 'longitude'>
    ) }
  )>>, readonly org: (
    { readonly __typename: 'Organization' }
    & Pick<Types.Organization, 'slug'>
  ) }
);

export type FundEntityOverviewFragment = FundEntityOverview_Portfolio_Fragment | FundEntityOverview_HoldingCompany_Fragment;

export const SubpageOverviewFragmentDoc = gql`
    fragment SubpageOverview on SubpageInterface {
  id
  slug
  title
  description
  restricted
  roles {
    id
    name
  }
  groups {
    id
    name
  }
}
    `;
export const FundEntityOverviewFragmentDoc = gql`
    fragment FundEntityOverview on FundEntity {
  id
  name
  hasSubpages
  subpagePermissions
  subpages {
    ...SubpageOverview
    ...SubpagesMenu
  }
  netYields {
    id
    year
    actualEnergy
    p50
    p90
  }
  projects {
    id
    name
    capacity
    type
    location {
      latitude
      longitude
    }
  }
  org {
    slug
  }
}
    ${SubpageOverviewFragmentDoc}
${SubpagesMenuFragmentDoc}`;
export const DeleteSubpageDocument = gql`
    mutation DeleteSubpage($subpageId: ID!, $subjectType: String!) {
  deleteSubpage(subpageId: $subpageId, subjectType: $subjectType) {
    success
  }
}
    `;
export type DeleteSubpageMutationFn = Apollo.MutationFunction<DeleteSubpageMutation, DeleteSubpageMutationVariables>;

/**
 * __useDeleteSubpageMutation__
 *
 * To run a mutation, you first call `useDeleteSubpageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSubpageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSubpageMutation, { data, loading, error }] = useDeleteSubpageMutation({
 *   variables: {
 *      subpageId: // value for 'subpageId'
 *      subjectType: // value for 'subjectType'
 *   },
 * });
 */
export function useDeleteSubpageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSubpageMutation, DeleteSubpageMutationVariables>) {
        return Apollo.useMutation<DeleteSubpageMutation, DeleteSubpageMutationVariables>(DeleteSubpageDocument, baseOptions);
      }
export type DeleteSubpageMutationHookResult = ReturnType<typeof useDeleteSubpageMutation>;
export type DeleteSubpageMutationResult = Apollo.MutationResult<DeleteSubpageMutation>;
export type DeleteSubpageMutationOptions = Apollo.BaseMutationOptions<DeleteSubpageMutation, DeleteSubpageMutationVariables>;